module.exports = __webpack_public_path__ + "img/jacob-min.709afd01.png";